var render, staticRenderFns
import script from "./LoadAnnotationGroupsMixin.vue?vue&type=script&lang=js"
export * from "./LoadAnnotationGroupsMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af72e70",
  null
  
)

export default component.exports